export const dashboardData = async (source, thunkApi) => {
  try {
    const { product } = thunkApi.extra.apiService;

    const response = await product.get("/dashboard", {
      params: {
        source,
      },
    });

    return response;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const dashboardBrand = async (data, thunkApi) => {
  try {
    const { source, filter } = data;
    const { product } = thunkApi.extra.apiService;

    const response = await product.get("/brand", {
      params: {
        source,
        filter,
      },
    });

    return response;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const dashboardCategory = async (data, thunkApi) => {
  try {
    const { source, filter } = data;
    const { product } = thunkApi.extra.apiService;

    const response = await product.get("/category", {
      params: {
        source,
        filter,
      },
    });

    return response;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const dashboardPriceRank = async (source, thunkApi) => {
  try {
    const { product } = thunkApi.extra.apiService;

    const response = await product.get("/pricerank", {
      params: {
        source,
      },
    });

    return response;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const dashboardPriceChanges = async (data, thunkApi) => {
  try {
    const { page, parameters } = data;
    const { user } = thunkApi.extra.apiService;

    let response;
    if (page === "dashboard") {
      response = await user.get("/price-change");
    } else {
      response = await user.get("/price-change", {
        params: {
          start_date: parameters.start,
          end_date: parameters.end,
        },
      });
    }

    return response;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const dashboardAllData = async (data, thunkApi) => {
  try {
    const {
      source,
      sort,
      offset,
      limit,
      pricerank,
      category,
      brand,
      location,
    } = data;
    const { user } = thunkApi.extra.apiService;

    const response = await user.get("/product", {
      params: {
        source,
        sort,
        offset,
        limit,
        pricerank,
        category,
        brand,
        location,
      },
    });
    return response;
  } catch (error) {
    return Promise.reject(error);
  }
};
